import { render } from "./ProposalReviewModal.vue.js?vue&type=template&id=1e3a7122!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProposalReviewModal.vue?vue&type=template&id=1e3a7122"
import script from "./ProposalReviewModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProposalReviewModal.vue?vue&type=script&lang=js"
export * from "./ProposalReviewModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProposalReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/ProposalReviewModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e3a7122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e3a7122', __exports__)) {
    api.reload('1e3a7122', __exports__)
  }
  
  module.hot.accept("./ProposalReviewModal.vue.js?vue&type=template&id=1e3a7122!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProposalReviewModal.vue?vue&type=template&id=1e3a7122", () => {
    api.rerender('1e3a7122', render)
  })

}


export default __exports__